import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { User } from '@models/identity/user';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '@services/form/form.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-user-dialog-content',
  templateUrl: './create-user-dialog-content.component.html',
  styleUrls: ['./create-user-dialog-content.component.scss']
})
export class CreateUserDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'CreateUserDialogContentComponent';

  @ViewChild('createUserComponent') createUserComponent;

  public inviteButtonActive: boolean = true;

  public customerId: number;

  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    injector: Injector
  ) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  newUserEvent(newUser: User) {
    this.inviteButtonActive = false;
    this.openInviteSuccessDialog();
  }

  newAnonymousUserEvent(newUser: User) {
    this.inviteButtonActive = false;
    this.openAnonymousInviteSuccessDialog();
  }

  getButtonDisabled() {
    if (!this.formService.form.valid) {
      return true;
    }
    if (!this.inviteButtonActive) {
      return true;
    }
    return false;
  }

  openInviteSuccessDialog() {
    Swal.fire({
      title: $localize`:@@InviteUserSuccessHeader:Die Einladung wurde an den Benutzer versendet!`,
      text: $localize`:@@InviteUserSuccessBody:Sie können dem Benutzer ab sofort RFID-Karten zuweisen und ihn an Ladestationen autorisieren.`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green',
    }).then((result) => {
      if (result.isConfirmed) {
        this.activeModal.close();
        this.router.navigate(['manage/users']);
      }
    })
  }
  openAnonymousInviteSuccessDialog() {
    Swal.fire({
      title: $localize`:@@InviteUserSuccessHeader:Der Benutzer wurde angelegt!`,
      text: $localize`:@@InviteUserSuccessBody:Sie können dem Benutzer ab sofort RFID-Karten zuweisen und ihn an Ladestationen autorisieren.`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green',
    }).then((result) => {
      if (result.isConfirmed) {
        this.activeModal.close();
        this.router.navigate(['manage/users']);
      }
    })
  }
}
